import { apiGet, apiPut } from '@api/api.utils'
import { IResponseCommon } from '@api/common.types'
import { IResponseAvatar, IResponseProfile } from './api.types'
import { ProfilePasswordFormType } from './state.types'

const route = '/profile'

/** Получение профиля текущего оператора */
export const getProfile = (): Promise<IResponseProfile> =>
    apiGet<IResponseProfile>(`${route}/getProfile`)

/** Смена пароля текущего оператора */
export const changePassword = (data: ProfilePasswordFormType): Promise<IResponseCommon> =>
    apiPut<IResponseCommon>(`${route}/changePassword`, undefined, data)

/** Сохранение выбранного аватара текущего оператора. */
export const changeAvatar = (avatarID: number): Promise<IResponseAvatar> =>
    apiPut<IResponseAvatar>(`${route}/changeAvatar`, undefined, {avatarID})
